import React from 'react'
import Button from '@mui/material/Button'
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded'

// 필터 폼 안에서 검색 조건을 기본값으로 돌리는 버튼의 공통 모양이다.
const defaultResetFilterButtonSx = {
    minWidth: 76,
    height: '36px',
    px: '12px',
    flexShrink: 0,
    alignSelf: 'center',
    whiteSpace: 'nowrap',
    fontWeight: 500,
    lineHeight: 1,
    color: 'text.secondary',
    borderColor: 'transparent',
    backgroundColor: 'background.default',
    transition: 'border-color 0.15s ease, background-color 0.15s ease, color 0.15s ease',
    '& .MuiButton-startIcon': {
        marginRight: 0.5,
        marginLeft: 0,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    '& .MuiSvgIcon-root': {
        fontSize: 16,
    },
    '&:hover': {
        color: 'text.primary',
        borderColor: 'divider',
        backgroundColor: 'background.default',
    },
    '&.Mui-disabled': {
        color: 'text.disabled',
        borderColor: 'transparent',
        backgroundColor: 'background.default',
    },
}

// 목록 검색/필터 초기화 버튼의 크기와 대비를 관리자 전역에서 맞춘다.
export default function ResetFilterButton({ label = '초기화', sx, ...props }) {
    return (
        <Button
            type="button"
            size="small"
            variant="outlined"
            startIcon={<RefreshRoundedIcon />}
            sx={{ ...defaultResetFilterButtonSx, ...sx }}
            {...props}
        >
            {label}
        </Button>
    )
}
